import { User } from '@apps-common/auth/client';
import {
  checkIsImpersonating,
  getImpersonationParams,
  saveImpersonationParams,
  updateClaimsForImpersonation,
} from '@modules/auth/components/lib/impersonation';
import { Claims, toInternalUser } from '@modules/auth/components/types/user';
import UserResource from '@src/services/Identity/UserResource';
import { getProjectAndAccount } from '@modules/auth/components/lib/account';
import { alertSuccess } from '@src/lib/alert';
import config from '@config/config';

import { AuthorizationProps } from '../../../types';

export function getClaims(authUser: User): Claims {
  return authUser.claims as Claims;
}

export async function setupOnAuthSuccess(claims: Claims, authProps: AuthorizationProps) {
  let userId: string = claims[config.userClaimsKey];
  let projectId: string = claims[config.accountClaimsKey];
  const { impersonatedUserId, impersonatedProjectId } = getImpersonationParams();
  const isImpersonating = checkIsImpersonating(impersonatedUserId, impersonatedProjectId);
  if (isImpersonating) {
    userId = impersonatedUserId!;
    projectId = impersonatedProjectId!;
  }
  const [serverUser, accountAndProject] = await Promise.all([
    UserResource.get({ userId }),
    getProjectAndAccount(projectId),
  ]);
  const user = toInternalUser(serverUser);

  if (accountAndProject === null) {
    return;
  }
  authProps.setAccount(accountAndProject.account);
  authProps.setProject(accountAndProject.project);
  if (isImpersonating) {
    updateClaimsForImpersonation(claims, impersonatedUserId!, impersonatedProjectId!);
    saveImpersonationParams(impersonatedUserId!, impersonatedProjectId!);
  }
  authProps.setLoggedIn(user, claims, isImpersonating);
  if (isImpersonating) {
    alertSuccess(`Managing: ${impersonatedProjectId}`);
  }
}
